import './ComponentsPanel.scss';

export { default as ComponentsPanel } from './ComponentsPanel';
export { default as getComponentsPanelSchema } from './schemas/componentsPanelSchema';
